import { BsCheckSquare } from "react-icons/bs"
import { useEffect, useState } from "react"
import { hotel_facts } from "../../common/facts";
import './styles.less';

export const AmenitiesCard = ({ fact, factValue, selected = true }) => {

    const [e, setE] = useState({
        Icon: BsCheckSquare,
        text: ''
    });

    useEffect(() => {
        let Icon = hotel_facts.en.facts[fact]?.icon ?? BsCheckSquare;
        setE({
            text: hotel_facts.en.facts[fact]?.label,
            Icon: Icon
        });
    }, [fact]);

    return (
        <div className='amenities-card d-flex align-items-top'>
            <i style={{
                color: 'black'
            }}> 
                <e.Icon />
            </i>
            <div>
                <p>{e.text}</p>
                {/* <ul>
                    {
                        factValue && factValue !== true ?
                            Object.keys(factValue).map(e => (
                                <li key={e}
                                    className="mb-1"
                                >
                                    {hotel_facts.en.attributes[e].label} {factValue[e].value ?
                                        (factValue[e].unitId === 1 && factValue[e].value > 500) ?
                                            `: ${factValue[e].value / 1000} ${hotel_facts.en.units['5'].label}` :
                                            `: ${factValue[e].value} ${factValue[e].unitId ? hotel_facts.en.units[`${factValue[e].unitId}`].label : ''}` : ''}
                                </li>
                            ))
                            :
                            null
                    }
                </ul> */}
            </div>
        </div>
    )
}